/**
 * ユーザー / 管理者が入力した URL を `href` / `src` / `window.open` に渡す前の検証 (docs/13 §7)。
 *
 * `javascript:` / `data:` / `vbscript:` などを `<a href>` に入れるとクリックでスクリプトが動く
 * (React は `javascript:` を警告するだけで止めない)。ここでは `new URL()` で解析し、
 * スキームが http / https のものだけを通す。
 *
 * - 前後の空白は取り除く。
 * - 相対 URL (`/foo`、`foo`) やスキーム無し (`example.com`) は通さない (null)。
 *   保存される URL は外部サイトを指す絶対 URL のはずなので、解釈の揺れを残さない。
 * - 返り値は `URL#href` (正規化済みの文字列)。
 */
export function safeHttpUrl(url) {
    if (typeof url !== 'string')
        return null;
    const trimmed = url.trim();
    if (trimmed.length === 0)
        return null;
    let parsed;
    try {
        parsed = new URL(trimmed);
    }
    catch {
        return null;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:')
        return null;
    if (!parsed.hostname)
        return null;
    return parsed.href;
}
/** `safeHttpUrl` が値を返すか (保存前の入力チェック用)。 */
export function isSafeHttpUrl(url) {
    return safeHttpUrl(url) !== null;
}
//# sourceMappingURL=safeHttpUrl.js.map